import tw from 'twin.macro';
import { TwitterIcon } from '@icons/TwitterIcon';
import { FacebookIcon } from '@icons/FacebookIcon';
import { LinkedinIcon } from '@icons/LinkedinIcon';
import { InstagramIcon } from '@icons/InstagramIcon';
import {
  SOCIAL_POST_ITEMS,
  useEpisodeDetailsContext,
} from '@insights_module/context/EpisodeDetailsContext';

const POSTS_DATA_MAPPER = {
  twitter: {
    icon: <TwitterIcon />,
    title: 'X Post',
  },
  facebook: {
    icon: <FacebookIcon />,
    title: 'Facebook Post',
  },
  linkedin: {
    icon: <LinkedinIcon />,
    title: 'LinkedIn Post',
  },
  instagram: {
    icon: <InstagramIcon />,
    title: 'Instagram Post',
  },
} as { [key: string]: { icon: JSX.Element; title: string } };

const SocialPostCardsContainer = tw.div`flex h-[106px] w-full items-start gap-[16px] self-stretch bg-neutral-background p-[16px] border-b border-b-gray-3`;
const SocialPostCard = tw.div`flex flex-1 flex-col items-center gap-[8px] self-stretch bg-page-background rounded-md px-[14px] py-[12px] shadow-social-media-inner fill-text-and-icon-muted stroke-text-and-icon-muted cursor-pointer hover:opacity-80`;

export const EpisodeDetailsSocialPostsHeader = () => {
  const { activeView, selectedSocialPostType, setSelectedSocialPostType } =
    useEpisodeDetailsContext();

  if (activeView !== 'social_posts') {
    return null;
  }

  return (
    <SocialPostCardsContainer>
      {SOCIAL_POST_ITEMS.map((type) => (
        <SocialPostCard
          key={type}
          css={[
            selectedSocialPostType === type &&
              tw`bg-sec-4 border border-gray-3 shadow-selected-social-inner`,
          ]}
          onClick={() => {
            setSelectedSocialPostType(type);
          }}>
          {POSTS_DATA_MAPPER[type].icon}
          <h3
            tw='text-[14px] text-text-and-icon-muted font-bold truncate'
            css={[selectedSocialPostType === type && tw`text-text-and-icon`]}>
            {POSTS_DATA_MAPPER[type].title}
          </h3>
        </SocialPostCard>
      ))}
    </SocialPostCardsContainer>
  );
};
